import React from 'react'
import { SystemProvider } from '../features/system/provider'
import { FilterForm } from './dashboard-listing'

const SidebarBasic = ({query, formOptions}) => {
  return (
    <div className="lg:pr-12">
      <SystemProvider>
        <FilterForm query={query} id="sidebar-filter-form" options={formOptions}/>
      </SystemProvider>
    </div>
  )
}

export { SidebarBasic }
